<template>
  <div
    class="hp-sidebar hp-bg-color-black-20 hp-bg-color-dark-90 border-right hp-border-color-black-40 hp-border-color-dark-80"
  >
    <div class="hp-sidebar-container">
      <div class="hp-sidebar-header-menu">
        <sidebar-header
          v-if="header"
          :collapsed="storeSidebarCollapsed"
          @sidebarCollapsedProps="sidebarCollapsed"
        />

        <ul>
          <sidebar-item
            :collapsed="storeSidebarCollapsed"
            :key="index"
            v-for="(item, index) in sidebarItems"
            :item="item"
          />
          <!-- <li>
            <b-link :href="documentation_link" variant="dark" class="text-black-100 hp-hover-bg-black-10 hp-hover-bg-dark-80 hp-hover-text-color-dark-0">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.3053 15.4497H8.90527"
                  stroke="#636E72"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.2603 11.4385H8.9043"
                  stroke="#636E72"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.1599 8.3L14.4899 2.9C13.7599 2.8 12.9399 2.75 12.0399 2.75C5.7499 2.75 3.6499 5.07 3.6499 12C3.6499 18.94 5.7499 21.25 12.0399 21.25C18.3399 21.25 20.4399 18.94 20.4399 12C20.4399 10.58 20.3499 9.35 20.1599 8.3Z"
                  stroke="#636E72"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.9341 2.83252V5.49352C13.9341 7.35152 15.4401 8.85652 17.2981 8.85652H20.2491"
                  stroke="#636E72"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <span v-if="!storeSidebarCollapsed" class="ml-1"
                >Документация</span
              >
            </b-link>
          </li> -->
        </ul>
      </div>
      <sidebar-footer :collapsed="storeSidebarCollapsed" />
    </div>
  </div>
</template>

<script>
import { BRow, BCol, BAvatar, BButton, BLink } from "bootstrap-vue";

import navigation from "../../../navigation/index";
import SidebarHeader from "./header";
import SidebarItem from "./item";
import SidebarFooter from "./footer";
import SidebarJs from "@/utils/sidebar-collapse-dropdown.js";

export default {
  props: {
    header: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  data() {
    return {
      sidebarItems: navigation,
      documentation_link: process.env.VUE_APP_DOCUMENTATION,
    };
  },
  components: {
    BRow,
    BCol,
    BAvatar,
    BButton,
    BLink,
    SidebarHeader,
    SidebarItem,
    SidebarFooter,
  },
  computed: {
    storeSidebarCollapsed() {
      return this.$store.state.themeConfig.sidebarCollapsed;
    },
  },
  methods: {
    sidebarCollapsed(check) {
      if (check) {
        this.$store.state.themeConfig.sidebarCollapsed = true;
      } else {
        this.$store.state.themeConfig.sidebarCollapsed = false;
      }

      document.body.classList.toggle("collapsed-active");
    },

    getDirection() {
      SidebarJs.sidebarCollapseDropdown();
    },
  },
  watch: {
    "$store.state.themeConfig.direction": {
      handler() {
        this.getDirection();
      },
      immediate: true,
    },
  },
};
</script>